import { J2000, J2000ObliquityDeg } from "../../AstroConstants.js";
import { Deg2Rad } from "../../../math/MathEx.js";
import { Quaternion } from "../../../math/Quaternion.js";
import { Vector3 } from "../../../math/Vector3.js";
export class SimpleRotationModel {
    _orientation;
    _ecliptic = false;
    period;
    static equatorial2ecliptic = Quaternion.AngleAxis(-1 * J2000ObliquityDeg * Deg2Rad, Vector3.Right());
    GetRotation(t, rp) {
        let rot = (t - J2000) / rp;
        rot -= Math.floor(rot);
        return rot * -1;
    }
    constructor(northPoleRA, northPoleDec, period, ecliptic) {
        this._ecliptic = ecliptic;
        this.period = period;
        this._orientation = this.northPoleRotation(northPoleRA, northPoleDec);
    }
    computeSpin(t) {
        return Quaternion.AngleAxis(2 * Math.PI * this.GetRotation(t, this.period), Vector3.Up());
    }
    computeEquatorOrientation() {
        return this._orientation;
    }
    northPoleRotation(raDeg, decDeg) {
        let qdec = Quaternion.AngleAxis((decDeg - 90) * Deg2Rad, Vector3.Forward());
        let qra = Quaternion.AngleAxis(raDeg * Deg2Rad, Vector3.Up());
        if (!this._ecliptic)
            return SimpleRotationModel.equatorial2ecliptic.multiply(qra.multiply(qdec));
        return qra.multiply(qdec);
    }
}
export class IAURotationModel {
    period;
    _flipped;
    static IauSecularTermValidCenturies = 50.0;
    constructor(period) {
        this._flipped = false;
        this.period = period;
    }
    IsPeriodic() {
        return true;
    }
    computeSpin(t) {
        // Time argument of IAU rotation models is actually day since J2000.0 TT, but
        // Celestia uses TDB. The difference should be so minute as to be irrelevant.
        t = t - J2000;
        let angle;
        if (this._flipped) {
            angle = 180.0 + this.Meridian(t);
        }
        else {
            angle = -(180.0 + this.Meridian(t));
        }
        angle -= 360.0 * Math.floor(angle / 360.0);
        return Quaternion.YRotation(Deg2Rad * angle);
    }
    static ClampCenturies(T) {
        if (T < -IAURotationModel.IauSecularTermValidCenturies) {
            return -IAURotationModel.IauSecularTermValidCenturies;
        }
        else if (T > IAURotationModel.IauSecularTermValidCenturies) {
            return IAURotationModel.IauSecularTermValidCenturies;
        }
        else {
            return T;
        }
    }
    SetFlipped(flipped) {
        this._flipped = flipped;
    }
    computeEquatorOrientation(t) {
        t = t - J2000;
        const coords = { ra: 0, dec: 0 };
        this.Pole(t, coords);
        const node = coords.ra + 90.0;
        const inclination = 90.0 - coords.dec;
        if (this._flipped)
            return Quaternion.XRotation(Math.PI)
                .multiply(Quaternion.XRotation(Deg2Rad * -inclination))
                .multiply(Quaternion.YRotation(Deg2Rad * -node));
        return Quaternion.XRotation(Deg2Rad * -inclination).multiply(Quaternion.YRotation(Deg2Rad * -node));
    }
}
